(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/betslipv2/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/app/betslipv2/assets/javascripts/init.js'); 
(function() {
  'use strict';

  svs = svs || {};
  svs.app = svs.app || {};
  svs.app.betslipv2 = svs.app.betslipv2 || {};
})();

 })(window);